import { render, staticRenderFns } from "./acceder.vue?vue&type=template&id=27a4ad06&"
import script from "./acceder.vue?vue&type=script&lang=js&"
export * from "./acceder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoginForm: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/forms/LoginForm.vue').default})
